<template>
  <div>
    <section aria-labelledby="history-title">
      <Card>
        <div class="divide-y divide-gray-200">
          <div class="px-4 py-5 sm:px-6">
            <h2 id="notes-title" class="text-lg font-medium text-gray-900">History</h2>
          </div>
          <div class="px-4 py-6 sm:px-6">
            <DataTable :columns="columns" :rows="history"> </DataTable>
          </div>
        </div>
      </Card>
    </section>
  </div>
</template>

<script>
import DataTable from '../../shared/DataTable/index.vue';
import Card from '../../Card/index.vue';
import { formatCurrencyToHuman, formatStandardDate } from '../../../utilities/format.ts';

export default {
  components: {
    DataTable,
    Card,
  },
  props: ['history'],
  computed: {
    columns() {
      return [
        { label: 'Start Date', key: 'start_date', sortable: false, formatter: formatStandardDate },
        { label: 'End Date', key: 'end_date', sortable: false, formatter: formatStandardDate },
        { label: 'Indeed', key: 'indeed_spend', sortable: false, formatter: formatCurrencyToHuman },
        { label: 'ZipRecruiter', key: 'zip_spend', sortable: false, formatter: formatCurrencyToHuman },
        { label: 'Monster', key: 'monster_spend', sortable: false, formatter: formatCurrencyToHuman },
        { label: 'Meta', key: 'meta_spend', sortable: false, formatter: formatCurrencyToHuman },
        { label: 'Total Spend', key: 'total_spend', sortable: false, formatter: formatCurrencyToHuman },
      ];
    },
  },
};
</script>
